import { ToastProvider } from '@jaymathew/ui-shared/contexts/ToastContext'
import { Loading } from '@jaymathew/ui-shared/elements/Loading'
import { Box, CircularProgress } from '@mui/material'
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'redux/store'
import LocalThemeWrapper from 'resources/localThemeWrapper'
import ScrollToTop from './ScrollToTop'
import ThemeSync from 'resources/ThemeSync'

const styles = {
	timelineFallback: {
		minHeight: '100vh',
		bgcolor: '#fff',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}

const RouteWrapper = () => {
	const location = useLocation()
	const isPublicMediaRoute = location.pathname.startsWith('/timeline') || location.pathname.startsWith('/download')

	const fallback = isPublicMediaRoute ? (
		<Box sx={styles.timelineFallback}>
			<CircularProgress size={40} thickness={2} />
		</Box>
	) : (
		<Loading />
	)

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<LocalThemeWrapper>
					<ThemeSync />
					<ToastProvider>
						<ScrollToTop>
							<Suspense fallback={fallback}>
								<Outlet />
							</Suspense>
						</ScrollToTop>
					</ToastProvider>
				</LocalThemeWrapper>
			</PersistGate>
		</Provider>
	)
}

export default RouteWrapper
